import React from "react";
import { BadgeCheck, MapPin, UserCircle } from "lucide-react";

// IMage
import avatar1 from "assets/images/users/avatar-1.png";

import useGuarantor from "hooks/useGuarantor";
import GuarantorCard from "../Gaurantor";

interface Props {
  userId: string;
}
const Guarantors = ({ userId }: Props) => {
  const { data, isLoading, refetch } = useGuarantor(userId);

  if (isLoading) return <p>Loading...</p>;

  return (
    <React.Fragment>
      <div className="flex flex-col gap-4">
        <h3>Guarantors</h3>
        {data?.data.map((guarantor) => (
          <GuarantorCard
            key={guarantor._id}
            data={guarantor}
            refetch={refetch}
          />
        ))}
      </div>
    </React.Fragment>
  );
};

export default Guarantors;
